module.exports = {
  text: `Кто мы такие, чтобы предполагать что то, что мы считаем обычным или нормальным — естественно для мультивселенной? Нужно понимать, что та жизнь, которую мы знаем — лишь одна из эпох сущего. Иглюды могут быть проводниками того, что однажды станет новым порядком существования. Возможно, если бы растения заменили всех других живых существ, Баланс стал бы намного прочнее.

Я, конечно же, просто найду себе новую материальную форму, чтобы и дальше нести свой дозор. Таково бремя стража — никогда не знать отдыха или настоящего покоя.`,
  author: `Морденкайнен`,
}
